var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0537 7.36743C24.4738 7.64799 24.2311 8.34583 24.5117 8.92546C25.2782 10.5088 25.6667 12.2155 25.6667 14C25.6667 20.4329 20.4329 25.6667 14 25.6667C7.5671 25.6667 2.33333 20.4329 2.33333 14C2.33333 7.5671 7.5671 2.33333 14 2.33333C16.6657 2.33333 19.17 3.20378 21.2427 4.85038C21.7454 5.25171 22.4805 5.16768 22.8819 4.66325C23.2832 4.1591 23.1992 3.4248 22.6945 3.02405C20.2406 1.07381 17.1528 0 14 0C6.2808 0 0 6.2808 0 14C0 21.7192 6.2808 28 14 28C21.7192 28 28 21.7192 28 14C28 11.8609 27.5329 9.81099 26.6117 7.90946C26.3317 7.32841 25.6316 7.0863 25.0537 7.36743Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 4.66699C13.3562 4.66699 12.8335 5.18966 12.8335 5.83366V14.0003C12.8335 14.6443 13.3562 15.167 14.0002 15.167H19.8335C20.4775 15.167 21.0002 14.6443 21.0002 14.0003C21.0002 13.3563 20.4775 12.8337 19.8335 12.8337H15.1668V5.83366C15.1668 5.18966 14.6442 4.66699 14.0002 4.66699Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/timeIcon.42e4b315d8177426a797d91d08bfd13f.svg";
export { ForwardRef as ReactComponent };